<script>
/* import { tableData } from './data-advance' */
// import EditModal from '../pages/job/editModal'
// import { mapActions } from 'vuex'
// import EditJob from '../pages/job/components/dialogs/edit.vue'
// import FormModal from '@pages/job/formModal'

import moment from 'moment/moment'
import Dialog from '@components/dialogs'
import OffCanvas from '@components/offcanvas'
import JobList from './list/jobList.vue'
import JobFilter from './list/jobFilter.vue'
import Loading from '@components/LoadingSpinner'
import { EventBus } from '../../event-bus'
import error from '@utils/error'

const _listTypes = {
  card:0,
  table:1,
}
export default {
  components:{
    Dialog,
    OffCanvas,
    // FormModal,
    // EditModal,
    JobList,
    JobFilter,
    Loading
  },
  props:['company_id', 'noTitle', 'type', 'hasFilter', 'isDashboard'],
	data() {
		return {
			title: this.$t('job.plural'),
			items: [],
			totalRows: 0,
			currentPage: 1,
			perPage: 20,
			pageOptions: [20, 50, 100, 200],
      jobStatus: 'All',
      statusOptions: ['All', 'Draft', 'Posted', 'Unposted'],
      sortOptions: [
        {value: 'min_salary', name: 'Minimum Salary'},
        {value: 'max_salary', name: 'Maximum Salary'},
        {value: 'updatedAt', name: 'Updated At'},
      ],
      sortByName: 'Select',
			filter: null,
			filterOn: [],
      params: {},
			sortBy: 'date_created',
			sortDesc: true,
      submitted: false,
			fields: [
				{ label: this.$t('job.table.job'), key:"title", sortable: true},
				{ label: this.$t('job.table.location'), key:'city', formatter: (val, key, item) => {
          return val + ', ' + item.country
        }, sortable: true },
        { label: this.$t('job.table.salary_range'), key:'salary', sortable: true },
        { label: this.$t('job.table.fees'), key:'rate', sortable: true},
        {
          key:'slots',
          label:this.$t('job.table.slots'),
          sortable: true
        },
        {
          key:'submitted',
          label:this.$t('job.table.submitted'),
          sortable: true
        },
        {
          key:'actions',
          label:''
        }
      ],
      isBusy:false,
      isFormModalOpen: false,
      isEditModalOpen: false,
      jobID: '',
      filterItems: {},
      listType: 'card', //card much default
		}
	},
	computed: {
		rows() {
			return this.totalRows
		},
    computedEditJobComponent() {
      return () => import('../pages/job/components/dialogs/edit.vue')
    },
    computedViewJobComponent() {
      return () => import('../pages/job/components/dialogs/view.vue')
    }
	},
	created() {
    EventBus.$on('onFetchJobData', this.fetchData)
    if(this.isDashboard || this.company_id)
      this.fetchData()
	},
  beforeDestroy() {
    EventBus.$off('onFetchJobData', this.fetchData)
  },
	methods: {
    onClickViewActions(val) {
      this.jobID = val.data._id

      if (val && val.type && val.type.toLowerCase() == 'ref') {
        this.$refs[val.ref].show()
      }
      else if (val && val.type && val.type.toLowerCase() == 'function') {
        this[val.func](val.data)
      }
    },
    syncJobs(){
      this.toggleBusy()
      // this.getVincereJob()
      this.$store.dispatch('job/getVincereJob')
      .then(res => {
        if(res.data.status){
          this.fetchData(true)
        }
			})
      .catch(err => {
        console.log(err);
			})
    },
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
    filterList(){
      this.fetchData()
    },
    onDeleteJob(val) {
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to delete this job (this action is one time only).`, {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if (typeof res == 'boolean' && res) {
          this.$store.dispatch('job/delete', { id: val._id })
          .then(res => {
            if (res && res.success) {
              this.fetchData()
              this.$refs.view_side_bar.hide()
              this.$refs.edit_side_bar.hide()
              this.$bvToast.toast(`Job #${val.reference_no} has been deleted!`, {
                title: 'Notification',
                variant:'success'
              })
            }
          })
          .catch(err => error.errorHandler(err, this.$bvToast))
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    onUpdateJobs(val) {
      this.submitted = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id

      return this.$store.dispatch('job/update', model)
      .then(res => {
        if (res && res.data) {
          this.fetchData()
          this.$refs.edit_side_bar.hide()
          this.$bvToast.toast(`${res.data.job.title} successfully updated!`, {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.submitted = false;
          }, 1500)
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    async fetchData(reload = false, type = 'active', useProps = true, hrflow = false) {
      this.items = []
      if(!reload)
        this.toggleBusy()
        
      if(useProps)
        type = this.type

      let skip = this.currentPage <= 1 ? 0 : (this.currentPage - 1) * this.perPage
      let params = {}
      let items = this.filterItems
      let min = ''

      if(items.sortBy) {
        this.sortBy = items.sortBy
        this.sortDesc = items.isDesc
        min = this.sortBy != 'update_at' ? '0' : ''
      }

      if(items.startDate || items.endDate) {
        params.created_at_min = this.params.created_at_min || items.startDate || ''
        params.created_at_max = this.params.created_at_max || items.endDate || ''
      }

      params.limit = this.perPage
      params.start = skip
      params.company_id = this.company_id || items.company || ''
      params.function_id = items.function_id || ''
      params.brand_id = items.brand_id || ''
      // params.status = items.status || ''
      params.rate = items.commission || ''
      params.minimum = items.minimumSalary || min || ''
      params.maximum = items.maximumSalary || ''
      params.filter = this.filter || items.filter || ''
      params.type = type
      params.job_status = this.hasFilter && items.status ? items.status : this.jobStatus
      params.sort_by = this.sortBy
      params.sort_desc = this.sortDesc
      if(hrflow){
        params = {
          ...params,
          ...this.params
        }
      }

      this.$store.dispatch('job/pagination', { ...params })
      .then(res => {
        this.totalRows = res.data.total
        this.items = res.data.data
        this.toggleBusy()
      })

      return this.items
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },
    openFormBar(id, editMode = false) {
      this.jobID = id
      if(!editMode){
        this.$refs.view_side_bar.show()
        // this.$refs.edit_side_bar.hide()
      }else{
        // this.$refs.edit_side_bar.show()
        this.$refs.view_side_bar.hide()
        this.$router.push({path: '/job/edit', query: { id: id }})
      }
    },
    closeFormBar(result){
      this.isFormModalOpen = result
    },
    closeEditFormBar(result){
      this.isEditModalOpen = result
    },
    afterEdit(){
      this.isFormModalOpen = !this.isFormModalOpen
      this.isEditModalOpen = !this.isEditModalOpen
    },
    sortChange(sortValue){
      this.sortBy = sortValue.sortBy
      this.sortDesc = sortValue.sortDesc
      this.fetchData().catch(error => {
        console.error(error)
      })
    },
    exportData(){
      let type = this.type
      let {filter, minimumSalary, maximumSalary, status, company, function_id, brand_id, startDate, endDate} = this.filterItems
      this.$store.dispatch('job/downloadData', {
        filter,
        type,
        company_id: company,
        function_id: function_id,
        brand_id: brand_id,
        job_status: status || 'All',
        minimum : minimumSalary,
        maximum : maximumSalary,
        created_at_min: startDate,
        created_at_max: endDate,
        sort_by: this.sortBy,
        sort_desc: this.sortDesc
      })
      .then(res => {
        if(res.data.errorMessage){
          alert(res.data.errorMessage)
        }else{
          if(res.data.length > 0){
            let { data } = res
            // const url = res.data.url
            // const link = document.createElement('a')
            // link.href = url
            // link.setAttribute('download', res.data.fileName) //or any other extension
            // link.setAttribute('target', '_blank') //or any other extension
            // document.body.appendChild(link)
            // link.click()
            // link.remove()
            
            window.open (data[1].url,"_blank")
            setTimeout(() => {
              window.open (data[0].url,"_self")
            }, 1)
          }
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    onFilter(val){
      this.filterItems = { ...val } || this.filterItems
      this.fetchData().catch(error => {
        console.error(error)
      })
    },
    onGenerateUrl(job){
      let jobs = this.items
      for(let key in jobs){
        if(jobs[key]._id == job.id){
          if (job.is_company) jobs[key].job_company_url = job.url
          else jobs[key].job_url = job.url
        }
      }

      this.items = jobs
    },
    onSearchField(val) {
      let model = val && val.model && Object.entries(val.model).length ? val.model : {};
      this.params = { ...model }
      if(!val.is_reset) {
        this.fetchData(false, 'active', true, true).catch(error => {
          console.error(error)
        })
      }
    },
    onSortBy(sortBy){
      this.sortByName = sortBy.name
      this.onFilter({
        sortBy: sortBy.value,
        isDesc: !this.sortDesc
      })
    },
    toggleList(e) {
      let toggleListSwitch = this.$refs['toggleListSwitch'],
        children = toggleListSwitch.children
      this.listType = e.target.value
      for(var key in children){
        if(typeof children[key] == 'object'){
          children[key].classList.add('btn-white-primary')
          children[key].classList.remove('btn-primary')
        }
      }

      if(e.target){
        e.target.classList.add('btn-primary')
        e.target.classList.remove('btn-white-primary')
      }
    },
  },
  mounted() {
    this.toggleList({
      target:this.$refs['toggleListSwitch'].children[_listTypes[this.$route.query.listType || 'card']]
    })
  },
  filters: {
    formatdate: function (value) {
      if (!value) return ''

      return moment(value).format('YYYY-MM-DD')
    }
  },
  watch: {
    company_id: function () {
      if (this.company_id) {
        this.fetchData()
      }
    },
    currentPage: {
      handler: async function() {
        await this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    perPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    jobStatus: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
  }
}
</script>
<template>
  <div class="row">
    <div class="col-12">
      <div class="">
        <div class="">
          <!-- <div class="row align-items-center mb-2" v-if="!noTitle">
            <div class="col">
                <label class="font-weight-bold d-inline mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-hard-drive icon-dual icon-xs mr-2"><line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line></svg>
                {{ title }}: </label>
            </div>
            <div class="col text-md-right" v-if="role_modules.some(item => item.value == 'job.export')">
                <button class="btn2 btn2-secondary btn2-sm" @click="exportData"><i class="uil uil-file-download"></i></button>
            </div>
          </div> -->
          <JobFilter 
            v-if="hasFilter"
            @onFilter="onFilter"
            @onSearchField="onSearchField"
            @onExportData="exportData"
            @sortChange="sortChange"
          >
            <template v-slot:custom-filter2>
              <slot name="custom-filter"></slot>
              <div class="dataTables_filter text-md-right">
                <div class="btn-group ml-1" ref="toggleListSwitch">
                  <button type="button" class="btn btn-white-primary" @click="toggleList" value="card">
                    <i class="uil-document-layout-left" style="pointer-events: none;"></i>
                  </button>
                  <button type="button" class="btn btn-white-primary" @click="toggleList" value="table">
                    <i class="uil-list-ul" style="pointer-events: none;"></i>
                  </button>
                </div>
              </div>
            </template>
            <template v-slot:joblist>
                 <!-- Table -->
                <div
                  v-if="!isBusy && !items.length"
                  class="m-auto h-100"
                  style="z-index: 10; align-items: center; display:flex;"
                >
                  <div class="m-auto h-100"
                  style="z-index: 1; align-items: center; display:flex;">Empty data found</div>
                </div>

                <Loading v-else-if="isBusy && !items.length" customClass="true" :loading="true" title="Loading..." class="m-auto h-100"/>
                
                <JobList 
                  :listType="listType"
                  :items="items"
                  :companyID="company_id"
                  @onView="openFormBar"
                  @fetchData="fetchData"
                  @onGenerateUrl="onGenerateUrl"
                  v-else
                />
                <div class="pl-3 d-flex align-items-center justify-content-between">
                  <div class="ml-2 align-items-center">
                    <label 
                      v-if="(items.length || totalRows) && !isBusy" 
                      class=""
                      style="font-weight: 500; opacity: 0.8; color: #030013;"
                    >Result Found: {{!items.length ? items.length : totalRows}}</label>
                  </div>
                  <div class="">
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination 
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="">
                      <div class="dataTables_length">
                        <label class="dataTable_entries">
                          <div >{{$t('common.show')}} {{$t('common.entries')}}</div>
                          <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                          ></b-form-select>
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="ml-1">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-right"
                      >
                        <b-row>
                          <b-col>
                            <label v-if="!hasFilter" class="d-inline-flex align-items-center dataTable_entries">
                              <span >{{$t('common.status')}}</span>
                              <b-form-select
                                v-model="jobStatus"
                                size="sm"
                                :options="statusOptions"
                              ></b-form-select>
                            </label>
                            <label v-if="!hasFilter" class="d-inline-flex align-items-center">
                              Search:
                              <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Search..."
                                class="form-control form-control-sm ml-2"
                                @keydown.enter.native="filterList"
                              ></b-form-input>
                            </label>
                            <label class="dataTable_entries">
                              <div class="text-left">Sort by:</div>
                              <b-nav-item-dropdown
                                right
                                no-caret
                                variant="black"
                                class="dropdown custom-dropdown"
                                style="padding-left: 0 !important;"
                              >
                                <template v-slot:button-content>
                                  <button class="custom-select custom-select-sm">
                                    {{ sortByName }}
                                  </button>
                                </template>
                                <b-dropdown-item 
                                  v-for="(item, idx) in sortOptions"
                                  :key="idx"
                                  href="javascript:void(0);"
                                  class="notify-item"
                                  @click.native="onSortBy(item)"
                                >
                                  {{ item.name }}
                                  <i v-if="sortBy == item.value && sortDesc" class="uil uil-angle-up ml-1" />
                                  <i v-if="sortBy == item.value && !sortDesc" class="uil uil-angle-down ml-1" />
                                </b-dropdown-item>
                              </b-nav-item-dropdown>
                            </label>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                    <!-- End search -->
                  </div>
                </div>
            </template>
          </JobFilter>
        
          <!--CREATED-->
        </div>
      </div>
    </div>
    <OffCanvas
      width="1200"
      centered
      title="View Job"
      ref="view_side_bar"
      bodyClass="modalBodyContainer px-4"
      size="xl"
      :component="computedViewJobComponent"
      :parameters="{ jobID, submitted }"
      @onClick="onClickViewActions"
    />
    <Dialog
      autoload
      centered
      yesText="Update"
      noText="Cancel"
      title="Update Job(s)"
      ref="edit_side_bar"
      size="xl"
      :component="computedEditJobComponent"
      :parameters="{ jobID }"
      @onYes="onUpdateJobs"
    />
  </div>
</template>

<style lang="scss">
  .modalBodyContainer {
    background: #e8eaee;
    overflow: auto;
    height: 80vh;
  }

  .small_text {
    font-size: 12px;
    padding-top: 0;
  }

  .company_name {
    // color: rgb(0, 94, 255);
    font-weight: bolder;
  }
  .custom-dropdown{
    .nav-link{
      padding: 0
    }
  }

</style>